import { render, staticRenderFns } from "./FormRequirementLocale.vue?vue&type=template&id=eff8ed94&scoped=true&"
import script from "./FormRequirementLocale.vue?vue&type=script&lang=js&"
export * from "./FormRequirementLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff8ed94",
  null
  
)

export default component.exports